// eslint-disable-next-line no-restricted-imports
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: center;\n  margin: 1em;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "Please type to search"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import { useQuery } from "@tanstack/react-query";
import { Select, Spin } from "antd";
import React, { useState, useMemo, useEffect } from "react";
import styled from "styled-components";
import { t } from "ttag";
import { useDebouncedCallback } from "use-debounce";
import NotFoundContent from "../NotFoundContent";
var Box = styled.div(_templateObject());
var dropdownRender = function(menu) {
    var _menu_props;
    if ((menu === null || menu === void 0 ? void 0 : (_menu_props = menu.props) === null || _menu_props === void 0 ? void 0 : _menu_props.searchValue) === "") {
        return /*#__PURE__*/ React.createElement(NotFoundContent, {
            description: t(_templateObject1())
        });
    }
    return menu;
};
var SearchQuerySelect = /*#__PURE__*/ React.forwardRef(function(_param, ref) {
    var _param_debounceMs = _param.debounceMs, debounceMs = _param_debounceMs === void 0 ? 500 : _param_debounceMs, value = _param.value, onChange = _param.onChange, getQueryOptions = _param.getQueryOptions, options = _param.options, rest = _objectWithoutProperties(_param, [
        "debounceMs",
        "value",
        "onChange",
        "getQueryOptions",
        "options"
    ]);
    var _useState = _slicedToArray(useState(""), 2), searchTerm = _useState[0], setSearchTerm = _useState[1];
    var debouncedSetSearch = useDebouncedCallback(function(search) {
        return setSearchTerm(search);
    }, debounceMs);
    // Cleanup debounced callback on unmount
    useEffect(function() {
        return function() {
            debouncedSetSearch.cancel();
        };
    }, [
        debouncedSetSearch
    ]);
    // Get query options based on the debounced search term
    var queryOptions = useMemo(function() {
        return getQueryOptions(searchTerm);
    }, [
        searchTerm,
        getQueryOptions
    ]);
    // Use React Query to fetch data
    var _useQuery = useQuery(_objectSpreadProps(_objectSpread({}, queryOptions), {
        enabled: !!queryOptions
    })), data = _useQuery.data, isLoading = _useQuery.isLoading, isFetching = _useQuery.isFetching;
    // Determine if we're currently fetching
    var fetching = isLoading || isFetching;
    return /*#__PURE__*/ React.createElement(Select, _extends({}, rest, {
        showSearch: true,
        ref: ref,
        value: value,
        onChange: onChange,
        filterOption: false,
        onSearch: debouncedSetSearch,
        loading: fetching,
        notFoundContent: fetching ? /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(Spin, {
            size: "small"
        })) : /*#__PURE__*/ React.createElement(NotFoundContent, null),
        dropdownRender: dropdownRender,
        options: options(data)
    }));
});
export default SearchQuerySelect;
